// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

const styles = (theme: any) => ({
  outputConfidenceBorder: {
    borderStyle: 'solid',
    padding: '20px 0',
    borderColor: '#7DD5D8',
    marginBottom: theme.spacing(2),
    borderWidth: '1px',
  },
  errorIcon: {
    marginLeft: '15px',
    height: '30px',
    width: '30px',
    color: '#01A1DD',
    float: 'left',
  },
  dataTypes: {
    marginTop: theme.spacing(2),
    paddingBottom: theme.spacing(1),
    fontWeight: 400,
    fontSize: '15px',
  },
  outputConfidence: {
    textAlign: 'left',
    paddingLeft: '55px',
    fontWeight: 400,
    fontSize: '15px',
  },
  uploadForm: {
    margin: '0 auto',
    width: 630,
    textAlign: 'center',
    height: '100%',
  },
  openFileDialogLink: {
    color: theme.palette.secondary.main,
    background: 'none!important',
    border: 'none',
    padding: '0!important',
    font: 'inherit',
    '&:hover': {
      textDecoration: 'underline',
      cursor: 'pointer',
    },
  },
  uploadFormText: {
    display: 'inline',
  },
  uploadFormTextTitle: {
    fontWeight: 600,
    fontSize: '20px',
    marginTop: theme.spacing(2),
  },
  uploadFormTextSubtitle: {
    fontSize: '14px',
    fontWeight: 400,
    marginTop: theme.spacing(0.5),
    color: '#788898',
  },
  uploadFormTextContainer: {
    textAlign: 'start',
  },
  uploadFilesActionsContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    paddingTop: theme.spacing(2),
    borderTop: '1px solid #E0E0E0',
  },
  noDataMessage: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  whatToUpload: {
    fontSize: '16px',
    fontWeight: 800,
    color: '#788898',
  },
  progressSectionContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  uploadFormIcon: {
    marginBottom: theme.spacing(1),
  },
  formText: {
    marginTop: theme.spacing(2),
    fontWeight: 400,
    fontSize: '15px',
  },
  uploadFormHeader: {
    marginBottom: theme.spacing(1),
  },
  uploadFormSubmit: {
    paddingLeft: theme.spacing(11),
    paddingRight: theme.spacing(11),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  progressSectionsWrapper: {
    marginBottom: '30px',
    marginTop: '20px',
    paddingRight: '20px',
    maxHeight: '200px',
    overflowY: 'scroll',
    '&::-webkit-scrollbar': {
      '-webkit-appearance': 'none',
    },
    '&::-webkit-scrollbar:vertical': {
      width: '11px',
    },
    '&::-webkit-scrollbar:horizontal': {
      height: '11px',
    },
    '&::-webkit-scrollbar-thumb': {
      borderRadius: '8px',
      border: '2px solid white',
      backgroundColor: 'rgba(0, 0, 0, .5)',
    },
  },
  progressSection: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(1),
    position: 'relative',
  },
  fileExtension: {
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5),
    margin: theme.spacing(1),
    width: 55,
  },
  fileExtensionText: {
    color: 'white',
  },
  progress: {
    flex: 1,
  },
  progressText: {
    textAlign: 'start',
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    maxWidth: '170px',
    width: '100%',
    display: 'block',
  },
  progressPercentageTextCenter: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  clearIconContainer: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'end',
  },
  backgroundMediumBlue: {
    '& .MuiLinearProgress-barColorPrimary': {
      backgroundColor: '#3369A0',
    },
    backgroundColor: '#3369A050',
  },
  backgroundAqua: {
    '& .MuiLinearProgress-barColorPrimary': {
      backgroundColor: '#7DD5D8',
    },
    backgroundColor: '#7DD5D850',
  },
  backgroundGold: {
    '& .MuiLinearProgress-barColorPrimary': {
      backgroundColor: '#FAA738',
    },
    backgroundColor: '#FAA73850',
  },
  progressButtons: {
    position: 'absolute',
    right: 0,
  },
  progressButton: {
    padding: theme.spacing(0.5),
  },
  cancelIcon: {
    fontSize: '16px',
    verticalAlign: 'middle',
  },
  finishedIcon: {
    fontSize: '16px',
    verticalAlign: 'middle',
    marginRight: theme.spacing(1),
    color: theme.palette.darkGrey,
  },
  anchorTag: {
    color: '#7DD5D8',
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
      cursor: 'pointer',
    },
  },
  fileSizeText: {
    color: '#000000',
    fontSize: '16px',
    padding: theme.spacing(1),
    display: 'inline',
    textAlign: 'center',
    fontWeight: 400,
  },
  dialogBox: {
    top: '100px',
    width: '90%',
    margin: '0 auto',
    padding: theme.spacing(2),
  },
  dialogTitle: {
    color: '#000000',
    fontSize: '20px',
    display: 'block',
    textAlign: 'left',
    fontWeight: 400,
    paddingTop: theme.spacing(5),
  },
  dialogContent: {
    paddingRight: theme.spacing(1),
    paddingLeft: theme.spacing(2.95),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(2),
    top: theme.spacing(2),
    color: theme.palette.grey[500],
  },
  epsgErrorMessage: {
    paddingLeft: theme.spacing(1),
    marginTop: theme.spacing(1),
  },
});

export default styles;
